import React, { useState, useEffect } from 'react';
import { Users, CheckCircle, Trophy, DollarSign, MousePointerClick, XCircle } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const PostAnalyticsCard = ({ postId, token }) => {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await fetch(`${API}/business/posts/${postId}/analytics`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) setAnalytics(await res.json());
      } catch (error) {
        console.error('Failed to fetch post analytics');
      }
    };
    if (postId && token) fetchAnalytics();
  }, [postId, token]);

  if (!analytics) return null;

  const metrics = [
    { icon: Users, label: 'Applications', value: analytics.applications, color: 'text-blue-400' },
    { icon: CheckCircle, label: 'Approved', value: analytics.approved, color: 'text-green-400' },
    { icon: Trophy, label: 'Deals Won', value: analytics.deals_won, color: 'text-brand-gold' },
    { icon: MousePointerClick, label: 'Link Clicks', value: analytics.tracking_clicks, color: 'text-purple-400' },
    { icon: DollarSign, label: 'Revenue', value: `$${(analytics.revenue || 0).toLocaleString()}`, color: 'text-emerald-400' },
  ];

  return (
    <div className="flex gap-3 flex-wrap" data-testid="post-analytics-card">
      {metrics.map((m) => {
        const Icon = m.icon;
        return (
          <div key={m.label} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#111317] border border-white/5 text-xs" data-testid={`post-metric-${m.label.toLowerCase().replace(/\s/g, '-')}`}>
            <Icon className={`w-3.5 h-3.5 ${m.color}`} />
            <span className="text-brand-muted">{m.label}</span>
            <span className="text-brand-text font-semibold">{m.value}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PostAnalyticsCard;
